import {FC} from 'react'
import {useHistory} from 'react-router-dom'
import {useForm, SubmitHandler, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {yup} from 'libs/yup'
import {useDispatch} from 'react-redux'
import {notifySuccess} from 'store/actions/notify'
import {asyncError} from 'store/actions/asyncError'
import {useMutation} from 'hooks/graphql'
import {Form} from './parts/Form'
import {Employee, Document, CREATE_EMPLOYEE_DOCUMENT_CONTRACT} from './query'

const schema = yup.object({
  title: yup.string().required().ensure().max(255).label('書類名'),
  comment: yup.string().notRequired().ensure().max(2000).label('コメント'),
  isPublished: yup.boolean().notRequired(),
  agreed: yup.boolean().required(),
})

export type Schema = yup.InferType<typeof schema>

interface PresenterProps {
  employee?: Employee
  documentIds: string[]
  documents?: {
    totalCount: number
    list: Document[]
  }
  loading: boolean
  per: number
  page: number
  setPage: (page: number) => void
  setPerPage: (per: number) => void
}

export const Presenter: FC<PresenterProps> = ({
  employee,
  documentIds,
  documents,
  loading,
  per,
  page,
  setPage,
  setPerPage,
}) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [createContract] = useMutation(CREATE_EMPLOYEE_DOCUMENT_CONTRACT)
  const methods = useForm<Schema>({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      title: '',
      comment: '',
      isPublished: false,
      agreed: false,
    },
  })

  const onSubmit: SubmitHandler<Schema> = async ({title, comment, isPublished}) => {
    if (!employee?.id || !documentIds.length) return

    try {
      await createContract({
        variables: {
          input: {
            employeeId: employee.id,
            documentIds,
            title,
            comment,
            isPublished,
          },
        },
      })
      history.push(`/documents/employees/${employee?.id}`)
      dispatch(notifySuccess('送信しました'))
      if (isPublished) {
        dispatch(notifySuccess('書類を公開しました'))
      }
    } catch (err) {
      dispatch(asyncError(err))
    }
  }

  return (
    <>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">電子契約送信</h1>
        <p className="m-title-main-note">「送信する」をクリックすると定価200円（税抜）が発生します。</p>
      </div>
      <div className="l-wrap-xl l-contents-wrap">
        <FormProvider {...methods}>
          <Form
            employee={employee}
            documents={documents}
            onSubmit={onSubmit}
            loading={loading}
            per={per}
            page={page}
            setPage={setPage}
            setPerPage={setPerPage}
          />
        </FormProvider>
      </div>
    </>
  )
}
